module.exports = __webpack_public_path__ + "img/instagram-icon.3576e8eb.svg";